import React, { useContext, useEffect } from "react";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import FilterPopup from "../FilterPopup";
import { ClientAccessFilterType, getSortedClientAccessLabels } from "./FilterTypes/ClientAccessFilterType";
import { TagRow } from "./TagFilter";

interface Props {
  initialClientAccesses: server.dto.ClientAccess[]
}

const ClientAccessFilter = (props: Props) => {
  const title = RESX.SoUser.Access;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  const reset = (): ClientAccessFilterType => ({
    selectedClientAccesses: [],
    clientAccesses: props.initialClientAccesses,
  });

  register("clientAccess", {
    getTitle: () => title,
    renderSelection: (filter) => {
      return <>{getSortedClientAccessLabels(filter).join(", ")}</>;
    },
    hasValue: (filter) => {
      return filter.selectedClientAccesses.length > 0;
    },
    reset,
    areEqual: (a, b) => {
      return areArrayValuesEqual(a.selectedClientAccesses.map(c => c.value), b.selectedClientAccesses.map(c => c.value));
    }
  });
  useEffect(() => {
    setInitialValue("clientAccess", reset());
  }, []);

  const [selectedClientAccesses, setSelectedClientAccesses] = React.useState<server.dto.ClientAccess[]>([]);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedClientAccesses(getValue("clientAccess").selectedClientAccesses);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("clientAccess", {
      selectedClientAccesses,
      clientAccesses: props.initialClientAccesses,
    });
    setPopupOpen(false);
  };

  const onToggle = (access: server.dto.ClientAccess) => {
    if (selectedClientAccesses.some(c => c.value === access.value)) {
      setSelectedClientAccesses(selectedClientAccesses.filter(c => c.value !== access.value));
    } else {
      setSelectedClientAccesses([...selectedClientAccesses, access]);
    }
  };

  const selectedClientAccessSet = new Set(selectedClientAccesses.map(c => c.value));

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<>
        <div className="margin-bottom">
          <div className="flex-column gap">
            {props.initialClientAccesses.map(access => (
              <TagRow
                key={access.value}
                selected={selectedClientAccessSet.has(access.value)}
                onToggle={() => { onToggle(access); }}
                tag={{
                  title: access.text,
                  code: access.text,
                  hexColor: access.hexColor,
                  tagId: 0,
                }}
              />
            ))}
          </div>
        </div>

        <div>
          <Button primary fluid onClick={onApply}>{RESX.SelectionManager.Apply}</Button>
        </div>
      </>}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default ClientAccessFilter;
